import {ListFilterValuesContext} from "../../../hooks/list/ListFilterValuesContext";
import {useOrganManagerShareFilterValues} from "./hooks/useOrganManagerShareFilterValues";
import {OrganManagerShareList} from "./OrganManagerShareList";

export function OrganManagerShareDetail() {
    const {pageInfoOnFilter, filterValues, searchList, listQueryType} = useOrganManagerShareFilterValues();


    return(
        <ListFilterValuesContext.Provider
            value={{
                filterValues,
                pageInfoOnFilter,
                searchList,
                listQueryType,
            }}
        >
            <OrganManagerShareList />
        </ListFilterValuesContext.Provider>
    )
}